import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {showAxiosError} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import "../memberList/MemberList.css";
import CityTransferModal from "./CityTransferModal";


class CityTransfer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedCity: null,
            cityList: [],
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            openCityTransferModal: false,
            isLoading: false,
            alert: null,
        };

        this.listCities = this.listCities.bind(this);
        this.cancelCityTransfer = this.cancelCityTransfer.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleTransfer = this.handleTransfer.bind(this);
    }

    listCities(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ("&sort=" + accessor + ',' + direction) : "&sort=id,asc";
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;

        let params = {
            url: API_BASE_URL + "/city/fetch?page=" + page + "&size=" + size + sortStr + searchQuery,
            method: "get",
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let cityList = response.data ? response.data.content : [];
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    cityList,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    handleLogout() {
        this.props.handleLogout();

    }

    cancelCityTransfer() {
        this.setState({
            openCityTransferModal: false,
            selectedCity: null,
        })
    }


    handleTransfer(item) {
        let self = this;
        self.setState({
            selectedCity: item,
            openCityTransferModal: true
        });
    }


    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true,
        }, () => this.listCities(this.state.accessor, this.state.direction, this.state.page, this.state.size))
    }

    render() {
        let cities = this.state.cityList;

        const columns = [
            {
                Header: "Plaka",
                accessor: "plakaKod",
            },
            {
                Header: "Ad",
                accessor: "ad",
            },
            {
                Header: "Oda",
                accessor: "",
                Cell: item => (
                    <label>{item.oda.ad && item.oda.ad.toString().substring(0, 25) + "..."}</label>
                )
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <button type="button"
                                onClick={() => this.handleTransfer(item)}
                                data-toggle="tooltip" data-placement="bottom" title="Transfer Et"
                                style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
                                rel="tooltip" className="Btn btn-sm btn-icon">
                            <i className="fas fa-exchange-alt"/>
                        </button>
                    </div>
                )
            }
        ];

        const fields = [
            {
                label: "Ad",
                accessor: "ad",
                type: "text",
                operator: "=",
            },
        ];

        return (<div className="row baseBackground">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                        <h4 className="card-title">Şehir Transfer İşlemleri</h4>
                    </div>
                    <div className="card-body mt-1">
                        <div className=" ">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch fields={fields}
                                                loading={this.state.searching}
                                                onSearch={this.handleSearch}/>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Table
                            loading={this.state.loading}
                            loadingText="Kayıtlar getiriliyor..."
                            content={cities}
                            total={this.state.total}
                            page={this.state.page}
                            manual={this.state.manual}
                            size={this.state.size}
                            options={["5", "10", "20", "50", "100"]}
                            columns={columns}
                            fetchData={this.listCities}
                        />
                    </div>
                </div>
                <Modal isOpen={this.state.openCityTransferModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelCityTransfer}>
                        Şehir Transferi
                    </ModalHeader>
                    {<ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <CityTransferModal cancelProcess={this.cancelCityTransfer}
                                           selectedCity={this.state.selectedCity}
                                           branches={this.props.allBranches}
                                           handleLogout={this.handleLogout}/>
                    </ModalBody>
                    }
                </Modal>
            </div>
        )
    }
}

export default CityTransfer



// WEBPACK FOOTER //
// ./src/page/cityTransfer/CityTransfer.js